import { createFileRoute } from '@tanstack/react-router';

type ScheduleRequestsFilters = {
  status?: string;
  startDate?: string;
  endDate?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/appointment')({
  staticData: { team: 'analytics' },
  validateSearch: (search: {
    comparingLocations?: boolean;
    customTableView?: 'prospect-list' | 'schedule-requests';
    filters?: ScheduleRequestsFilters;
  }) => {
    return {
      comparingLocations: search.comparingLocations,
      customTableView: search.customTableView,
      filters: search.filters,
    };
  },
});
